export default function(map, callback) {
    let result = [];
    let index = 0;
    for (let i of map) {
        const key = i[0];
        const value = i[1];
        const callbackResult = callback(key, value, index++);
        if (callbackResult) {
            result.push(callbackResult);
        }
    }
    return result;
}
